import { CategoryDirectory } from "../../directory/category";

export class responseListProduct {
    categories:Array<CategoryDirectory>;
    constructor(data) {
        this.categories = data.map(item => new CategoryDirectory(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-list-product.ts